import { render, staticRenderFns } from "./BlockPicker.vue?vue&type=template&id=9cf76a8c&scoped=true"
import script from "./BlockPicker.vue?vue&type=script&lang=js"
export * from "./BlockPicker.vue?vue&type=script&lang=js"
import style0 from "./BlockPicker.vue?vue&type=style&index=0&id=9cf76a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf76a8c",
  null
  
)

export default component.exports